import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";

export const SEARCH_MODE_QUERY_PARAM_KEY = "searchMode";
export const SHIFT_ID_QUERY_PARAM_KEY = "shiftId";
export const RETURN_TO_QUERY_PARAM_KEY = "returnTo";
export const REQUIRED_DATA_QUERY_PARAM_KEY = "requiredData";

export const RETURN_TO = {
  SHIFT_INVITE: "shiftInvite",
} as const;
export type ReturnToType = (typeof RETURN_TO)[keyof typeof RETURN_TO];

export const NON_REJECTED_WORKER_REQUIREMENT_STATUSES = Object.values(
  WorkerRequirementStatus
).filter((status) => status !== WorkerRequirementStatus.REJECTED);

export const BACKGROUND_CHECK_PAGE_SOURCE = {
  INTRO_PAGE: "INTRO_PAGE",
  DETAILS_PAGE: "DETAILS_PAGE",
  CONSENT_PAGE: "CONSENT_PAGE",
} as const;

export const BACKGROUND_CHECK_BUTTON_ACTION = {
  SUBMIT: "SUBMIT",
  BACK: "BACK",
} as const;
